// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-study-template-js": () => import("/opt/build/repo/src/templates/study-template.js" /* webpackChunkName: "component---src-templates-study-template-js" */),
  "component---src-templates-plain-page-template-js": () => import("/opt/build/repo/src/templates/plain-page-template.js" /* webpackChunkName: "component---src-templates-plain-page-template-js" */),
  "component---src-templates-page-template-js": () => import("/opt/build/repo/src/templates/page-template.js" /* webpackChunkName: "component---src-templates-page-template-js" */),
  "component---src-templates-product-template-js": () => import("/opt/build/repo/src/templates/product-template.js" /* webpackChunkName: "component---src-templates-product-template-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

